import { TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { WorkspaceSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";

/** The account the workspace pays its suppliers from — the debtor of every payment file. */
export function WorkspaceFormBankAccount() {
	/** Context */
	const methods = useFormContext<WorkspaceSchema>();
	const companyName = useWatch({ control: methods.control, name: "companyName" });

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack gap-6">
			<p className="label">{t("organization.bank_account_hint")}</p>
			<TextInput
				control={methods.control}
				name="bankAccountHolder"
				label={t("organization.bank_account_holder")}
				placeholder={companyName || undefined}
				isRequired={false}
				data-cy="workspace-bank-account-holder-input"
			/>
			<TextInput
				control={methods.control}
				name="iban"
				label={t("organization.iban")}
				placeholder="DE89 3704 0044 0532 0130 00"
				isRequired={false}
				data-cy="workspace-iban-input"
			/>
			<TextInput
				control={methods.control}
				name="bic"
				label={t("organization.bic")}
				placeholder="COBADEFFXXX"
				isRequired={false}
				data-cy="workspace-bic-input"
			/>
		</div>
	);
}
